module.exports = __webpack_public_path__ + "static/media/account-pedidos-vazio.61190fdc.png";